<template>
  <section v-if="crew.length" id="crew" class="crew-section" :class="{ 'crew-section-embedded': embedded }">
    <v-container :class="{ 'pa-0': embedded }">
      <p v-if="!embedded">{{ kicker }}</p>
      <component :is="embedded ? 'h3' : 'h2'">The Reckon Crew</component>
      <div class="crew-grid">
        <CrewCard
          v-for="member in crew"
          :key="member.employeeSlug || member.slug || member.id || member.name"
          :member="member"
          :trip-label="tripLabel"
        />
      </div>
    </v-container>
  </section>
</template>

<script>
import CrewCard from './CrewCard.vue';

export default {
  name: 'CrewSection',
  components: { CrewCard },
  props: {
    crew: { type: Array, default: () => [] },
    kicker: { type: String, default: 'The People' },
    tripLabel: { type: String, default: '' },
    embedded: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.crew-section { background: #050505; border-top: 1px solid #242424; padding: 72px 0; scroll-margin-top: 68px; }
.crew-section > .container > p { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: 2.8rem; margin: 0 0 28px; }
h3 { color: #fff; font-family: "Oswald", sans-serif; font-size: 1.5rem; margin: 0 0 12px; }
.crew-grid { display: grid; gap: 14px; grid-template-columns: repeat(auto-fit, minmax(min(100%, 240px), 1fr)); }
.crew-section-embedded { background: transparent; border: 0; margin-top: 26px; padding: 0; }
</style>
